import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Button, 
  TextField, 
  Box, 
  Typography,
  InputAdornment
} from '@mui/material';

/**
 * Component for the budget update dialog
 */
const BudgetDialog = ({ 
  open, 
  selectedCampaign, 
  newBudget, 
  handleClose, 
  handleBudgetChange, 
  handleUpdateBudget
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        Update Campaign Budget
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Set the new daily budget for campaign:{' '}
          <strong>{selectedCampaign?.name || selectedCampaign?.campaign_name || 'Selected Campaign'}</strong>
        </DialogContentText>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Current daily budget: <strong>
              {(() => {
                // Get budget based on platform
                const budgetValue = selectedCampaign?.platform === 'taboola'
                  ? selectedCampaign?.daily_cap
                  : selectedCampaign?.daily_budget;
                  
                // Check if we have a valid budget to display
                if (budgetValue !== undefined && budgetValue !== null && !isNaN(parseFloat(budgetValue)) && parseFloat(budgetValue) > 0) {
                  return `$${parseFloat(budgetValue).toFixed(2)}`;
                }
                
                return '-';
              })()}
            </strong>
          </Typography>
        </Box>
        <TextField
          fullWidth
          label="Daily Budget ($)"
          type="number"
          value={newBudget}
          onChange={handleBudgetChange}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          onClick={handleUpdateBudget} 
          variant="contained" 
          color="primary"
          disabled={!newBudget || parseFloat(newBudget) <= 0}
        >
          Update Budget
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BudgetDialog; 